import React, { useMemo } from 'react';

import type { ImageProps } from './Image.types';
import { BaseImage } from './subcomponents/BaseImage';
import { ResponsiveImage } from './subcomponents/ResponsiveImage';
import { getImageForCurrentScreen, withHttpsProtocol } from './Image.utils';

export const Image = (props: ImageProps) => {
  const { source, responsive, ...rest } = props;
  const formattedSource = useMemo(
    () => getImageForCurrentScreen(withHttpsProtocol(source)),
    [source],
  );

  return responsive ? (
    <ResponsiveImage source={formattedSource} {...rest} />
  ) : (
    <BaseImage source={formattedSource} {...rest} />
  );
};
